import { render, staticRenderFns } from "./AvatarNoti.vue?vue&type=template&id=1fdf2bff&"
import script from "./AvatarNoti.vue?vue&type=script&lang=js&"
export * from "./AvatarNoti.vue?vue&type=script&lang=js&"
import style0 from "./AvatarNoti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports